{
  "sidebar": {
    "profile": "My profile",
    "orders": "My orders",
    "addresses": "My addresses",
    "returns": "My returns",
    "invoices": "My invoices",
    "logout": "Log out",
    "wishlist": "My wishlist",
    "settings": "Settings"
  },

  "login": {
    "title": "Log in",
    "subtitle": "Access your Djayma customer area",
    "email_label": "Email address",
    "email_placeholder": "your@email.com",
    "password_label": "Password",
    "password_placeholder": "Your password",
    "forgot_password": "Forgot password?",
    "submit": "Log in",
    "no_account": "Don't have an account?",
    "create_account": "Create an account",
    "success_registered": "Account created successfully. You can now log in.",
    "error_email_required": "Please enter your email address.",
    "error_password_required": "Please enter your password.",
    "error_invalid_credentials": "Incorrect email or password.",
    "error_too_many_attempts": "Too many attempts. Try again in {{seconds}}s.",
    "error_generic": "An error occurred. Please try again.",
    "show_password": "Show password",
    "hide_password": "Hide password",
    "reason_timeout": "Your session has expired. Please sign in again.",
    "reason_login_required": "Sign in to access your account."
  },

  "register": {
    "title": "Create an account",
    "subtitle": "Join Djayma and place your orders online",
    "full_name_label": "Full name",
    "full_name_placeholder": "First and last name",
    "email_label": "Email address",
    "email_placeholder": "your@email.com",
    "phone_label": "Phone",
    "phone_placeholder": "+221 77 123 45 67",
    "password_label": "Password",
    "password_placeholder": "Minimum 8 characters",
    "password_confirm_label": "Confirm password",
    "password_confirm_placeholder": "Re-enter your password",
    "privacy_accept": "I accept the",
    "privacy_policy_link": "privacy policy",
    "privacy_and_terms": "and terms of service",
    "submit": "Create my account",
    "already_account": "Already have an account?",
    "login_link": "Log in",
    "error_name_required": "Please enter your full name.",
    "error_email_required": "Please enter your email address.",
    "error_privacy_required": "You must accept the privacy policy to create an account.",
    "error_phone_invalid": "Phone number must be in Senegalese format (+221 XX XXX XX XX).",
    "error_password_min": "Password must be at least 8 characters.",
    "error_password_mismatch": "Passwords do not match.",
    "error_generic": "An error occurred. Please try again.",
    "show_password": "Show password",
    "hide_password": "Hide password",
    "show_confirm_password": "Show confirm password",
    "hide_confirm_password": "Hide confirm password"
  },

  "reset_request": {
    "title": "Forgot password",
    "subtitle": "Enter your email address to receive a reset link.",
    "email_label": "Email address",
    "email_placeholder": "your@email.com",
    "submit": "Send reset link",
    "back_to_login": "Back to login",
    "sent_title": "Email sent",
    "sent_message": "If an account exists with <strong>{{email}}</strong>, you will receive a reset link shortly.",
    "check_spam": "Also check your spam folder.",
    "error_generic": "An error occurred. Please try again."
  },

  "reset_password": {
    "title": "New password",
    "subtitle": "Choose a new password for your account.",
    "password_label": "New password",
    "password_placeholder": "Minimum 8 characters",
    "password_confirm_label": "Confirm password",
    "password_confirm_placeholder": "Re-enter your password",
    "submit": "Update password",
    "success_title": "Password updated",
    "success_redirect": "Redirecting to your account...",
    "expired_title": "Link expired",
    "expired_message": "This reset link is invalid or has expired. Please request a new one.",
    "request_new_link": "Request a new link",
    "error_password_min": "Password must be at least 8 characters.",
    "error_password_mismatch": "Passwords do not match.",
    "error_generic": "An error occurred. Please try again.",
    "show_password": "Show password",
    "hide_password": "Hide password",
    "show_confirm_password": "Show confirm password",
    "hide_confirm_password": "Hide confirm password"
  },

  "profile": {
    "title": "My profile",
    "edit": "Edit",
    "full_name_label": "Full name",
    "email_label": "Email address",
    "phone_label": "Phone",
    "phone_placeholder": "+221 77 123 45 67",
    "phone_invalid": "Invalid phone format. Example: +221 77 123 45 67",
    "notifications_label": "Notification preferences",
    "notification_email": "Email",
    "notification_sms": "SMS",
    "notification_whatsapp": "WhatsApp",
    "language_label": "Preferred language",
    "language_fr": "French",
    "language_wo": "Wolof",
    "language_en": "English",
    "save": "Save",
    "cancel": "Cancel",
    "loading": "Loading profile...",
    "error_loading": "Unable to load profile",
    "retry": "Retry",
    "success_message": "Profile updated successfully.",
    "error_generic": "An error occurred."
  },

  "orders": {
    "title": "My orders",
    "empty_title": "No orders",
    "empty_message": "Your orders will appear here once placed.",
    "column_ref": "Reference",
    "column_date": "Date",
    "column_status": "Status",
    "column_total": "Total",
    "track": "Track",
    "order_again": "Order again"
  },

  "addresses": {
    "title": "My addresses",
    "add": "Add",
    "edit_title": "Edit address",
    "new_title": "New address",
    "label_field": "Label (e.g. Home, Office)",
    "label_placeholder": "Home",
    "phone_label": "Phone",
    "phone_placeholder": "+221 77 123 45 67",
    "address_label": "Full address",
    "address_placeholder": "Street 12, Villa 45",
    "quartier_label": "Neighborhood",
    "quartier_placeholder": "Hann Mariste",
    "commune_label": "Commune",
    "commune_placeholder": "Hann Bel-Air",
    "region_label": "Region",
    "region_select": "Select",
    "update": "Update",
    "save": "Save",
    "cancel": "Cancel",
    "default_badge": "Default",
    "set_default": "Set as default",
    "edit": "Edit",
    "delete": "Delete",
    "empty_title": "No addresses saved",
    "empty_message": "Add a delivery address to place an order.",
    "region_dakar": "Dakar",
    "region_kaolack": "Kaolack",
    "region_saint_louis": "Saint-Louis",
    "region_fatick": "Fatick",
    "region_thies_mbour": "Thies-Mbour",
    "region_diourbel_touba": "Diourbel-Touba"
  },

  "returns": {
    "title": "My returns",
    "request_button": "Request a return",
    "new_request_title": "New return request",
    "close_form": "Close form",
    "disabled_title": "Returns are not yet available.",
    "disabled_contact": "Contact us via WhatsApp at",
    "empty_title": "You have no return requests.",
    "empty_hint": "Click \"Request a return\" to submit a request.",
    "loading_error": "Unable to load your return requests.",
    "column_order": "Order",
    "column_date": "Date",
    "column_reason": "Reason",
    "column_status": "Status",
    "column_refund": "Refund",
    "form_order_label": "Related order",
    "form_order_placeholder": "Select an order",
    "form_no_orders": "No delivered orders available for return.",
    "form_reason_label": "Return reason",
    "form_reason_placeholder": "Describe the issue with your order (damaged product, wrong item, etc.)",
    "form_reason_count": "{{count}} / {{min}} characters minimum",
    "form_items_label": "Items to return",
    "form_items_hint": "optional — leave empty to return the entire order",
    "form_item_qty_available": "Qty available: {{qty}}",
    "form_item_qty_label": "Quantity to return:",
    "form_item_reason_label": "Note for this item (optional)",
    "form_item_reason_placeholder": "e.g. Opened packaging, expired product…",
    "form_submit": "Submit request",
    "form_submitting": "Submitting…",
    "form_cancel": "Cancel",
    "form_success_title": "Request submitted successfully",
    "form_success_message": "Your return request has been recorded.",
    "form_success_ref": "Return ref: {{id}}",
    "form_success_contact": "Our team will review your request and contact you within 48 hours.",
    "form_submit_error": "Error submitting (HTTP {{status}}). Please try again.",
    "form_photos_label": "Photos (optional)",
    "form_photos_hint": "Add up to 5 photos (5 MB max each) to help us process your request.",
    "form_photos_button": "Add photos",
    "form_photo_size_error": "Some photos exceed 5 MB. Please choose smaller files.",
    "form_photo_limit_error": "You can attach up to 5 photos only.",
    "policy_link": "View our returns policy",
    "status_requested": "Requested",
    "status_approved": "Approved",
    "status_rejected": "Rejected",
    "status_refund_pending": "Refund pending",
    "status_refunded": "Refunded",
    "status_closed": "Closed"
  },

  "order_status": {
    "pending": "Pending",
    "confirmed": "Confirmed",
    "processing": "Processing",
    "shipped": "Shipped",
    "delivered": "Delivered",
    "cancelled": "Cancelled"
  },

  "login_title": "Log in",
  "login_phone": "Phone number",
  "login_otp": "Verification code",
  "send_otp": "Send code",
  "verify": "Verify",
  "register_title": "Create an account",
  "profile_legacy": "My profile",
  "orders_legacy": "My orders",
  "addresses_legacy": "My addresses",
  "returns_legacy": "My returns",
  "no_orders": "You don't have any orders yet",
  "order_again": "Order again",
  "tracking_title": "Order tracking",
  "tracking_search": "Enter your order reference",

  "wishlist": {
    "title": "My wishlist",
    "empty": "You don't have any favourites yet",
    "empty_description": "Browse our catalogue and add your favourite products",
    "remove": "Remove",
    "add_to_cart": "Add to cart",
    "added_to_cart": "Added to cart",
    "removed": "Removed from wishlist",
    "browse_catalog": "Browse catalogue",
    "loading": "Loading your wishlist...",
    "error": "Unable to load your wishlist",
    "retry": "Retry",
    "out_of_stock": "Out of stock",
    "share": "Share",
    "share_created": "Share link created",
    "link_copied": "Link copied!",
    "share_error": "Unable to create share link",
    "revoke_link": "Revoke link",
    "share_revoked": "Share link revoked",
    "revoke_error": "Unable to revoke link",
    "copy_link": "Copy",
    "shared_loading": "Loading wishlist...",
    "shared_expired_title": "Link expired or revoked",
    "shared_expired_description": "This share link is no longer valid.",
    "shared_error": "Unable to load this list",
    "shared_default_title": "Wishlist",
    "shared_by": "{{name}}'s wishlist",
    "shared_empty": "This list is empty for now."
  },

  "settings": {
    "title": "Account settings",
    "password_title": "Change password",
    "password_current": "Current password",
    "password_new": "New password",
    "password_new_placeholder": "Minimum 8 characters",
    "password_confirm": "Confirm new password",
    "password_confirm_placeholder": "Re-enter your new password",
    "password_submit": "Change password",
    "password_success": "Password changed successfully.",
    "password_error": "Unable to change password.",
    "password_current_wrong": "Current password is incorrect.",
    "password_min_error": "Password must be at least 8 characters.",
    "password_mismatch_error": "Passwords do not match.",
    "notifications_title": "Notification preferences",
    "notifications_description": "Choose how you want to be notified",
    "channel_email": "Email",
    "channel_sms": "SMS",
    "channel_whatsapp": "WhatsApp",
    "prefs_updated": "Preferences updated",
    "export_title": "Export my data",
    "export_description": "In accordance with Senegalese data protection law (Loi n° 2008-12), you can download a copy of all your data.",
    "export_button": "Download my data",
    "exporting": "Exporting...",
    "export_success": "Data exported successfully",
    "export_error": "Unable to export your data",
    "delete_title": "Delete my account",
    "delete_description": "This action is irreversible. Your account and all data will be deleted within 30 days.",
    "delete_button": "Request deletion",
    "delete_confirm_title": "Confirm deletion",
    "delete_confirm_message": "Are you sure you want to delete your account? This action is irreversible.",
    "delete_reason_label": "Reason (optional)",
    "delete_reason_placeholder": "Tell us why you want to delete your account...",
    "delete_confirm_button": "Confirm deletion",
    "delete_cancel": "Cancel",
    "delete_success": "Your deletion request has been recorded. It will be processed within 30 days.",
    "delete_error": "Unable to submit deletion request"
  },

  "order_detail": {
    "title": "Order detail",
    "reference": "Reference",
    "date": "Date",
    "items": "Items",
    "quantity": "Qty",
    "unit_price": "Unit price",
    "line_total": "Total",
    "subtotal_ht": "Subtotal (excl. tax)",
    "tva": "VAT",
    "delivery_fee": "Delivery fee",
    "total_ttc": "Total (incl. tax)",
    "payment": "Payment",
    "payment_method": "Payment method",
    "payment_status": "Payment status",
    "delivery": "Delivery",
    "delivery_address": "Delivery address",
    "delivery_status": "Delivery status",
    "estimated_delivery": "Estimated delivery",
    "track": "Track delivery",
    "reorder": "Order again",
    "back": "Back to orders",
    "not_found": "Order not found",
    "loading": "Loading...",
    "error": "Unable to load order"
  },

  "orders.view_detail": "View detail",
  "orders.reorder": "Order again",
  "orders.reorder_success": "Items added to cart",
  "orders.reorder_error": "Unable to reorder",
  "orders.loading": "Loading your orders...",
  "orders.empty": "You don't have any orders yet",
  "orders.empty_description": "Your orders will appear here once placed.",
  "orders.reference": "Reference",
  "orders.date": "Date",
  "orders.status": "Status",
  "orders.total": "Total",
  "orders.error": "Unable to load your orders",
  "orders.error_description": "Please try again shortly.",
  "orders.retry": "Retry",
  "orders.load_more": "Load more",
  "orders.loading_more": "Loading...",
  "orders.total_count": "{{count}} order",
  "orders.total_count_plural": "{{count}} orders",

  "register.link_order_hint": "Your order will be automatically linked to your new account.",

  "email_verification": {
    "title": "Verify your email",
    "description": "A verification email has been sent to your address. Click the link to activate your account.",
    "resend": "Resend email",
    "resent_success": "Verification email resent",
    "resend_no_email": "Please sign up again to resend the email.",
    "resend_generic_error": "Unable to resend the email. Try again in a few moments.",
    "spam_hint": "If you don't see anything after 2 minutes, check your spam folder or contact contact@cieda.sn.",
    "back_to_login": "Back to login"
  }
}
